import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../icon/Icon';
import styles from './states.module.css';
export function StaleNote({ asOf = null, onRetry }) {
    const dated = asOf !== null && asOf.trim() !== '';
    return (_jsxs("div", { className: styles.paused, role: "status", "aria-live": "polite", children: [_jsx(Icon, { name: "unsure" }), _jsx("span", { children: dated
                    ? `A refresh just failed — showing the answer from ${asOf}.`
                    : 'A refresh just failed — showing the last answer we got.' }), _jsx("span", { className: styles.pausedSpacer }), onRetry ? (_jsx("button", { type: "button", className: styles.retryBtn, onClick: onRetry, children: "Retry now" })) : null] }));
}
//# sourceMappingURL=StaleNote.js.map